export const SET_LANGUAGE = "SET_LANGUAGE";


// WEBPACK FOOTER //
// ./modules/custom-language-watcher/actions/actionTypes.ts